export default __webpack_public_path__ + "static/media/bg3.1ded40a0.jpg";